
export const MAP_IMAGE_LAYER_URL = "https://www.horrycountysc.gov/parcelapp/rest/services/HorryCountyGISApp/MapServer"

